module.exports = __webpack_public_path__ + "static/glinkaStagnation-ff4b56a38a1c7f12b871be9c1b83d287.mp3";